export enum BiMessageStatus{
    WAITING_FOR_APPROVAL = 'WFA',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED'
}

export const biMessageStatusDisplayValues = {
    WFA : 'Waiting For Approval',
    APPROVED : 'Approved',
    REJECTED : 'Rejected'
}


